import { useQuery } from "@tanstack/react-query";
import useApiAdmin from "./useApiAdmin";

const useAdminListUser = (token: string) => {
    const { listUser } = useApiAdmin();

    return useQuery({
        queryKey: ["listUser"],
        queryFn: () => listUser(token),
        staleTime: 1000 * 60 * 5,
        placeholderData: (previousData) => previousData,
    })
}

export default useAdminListUser;